import { initialState } from './reducer';
import { createSelector } from 'reselect';
export var selectPaymentModal = function (state) {
    return (state === null || state === void 0 ? void 0 : state.paymentSettings) || initialState;
};
export var makeSelectPaymentModal = function () {
    return createSelector(selectPaymentModal, function (paymentSettings) { return paymentSettings; });
};
